import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';

interface PdfViewerModalProps {
    onClose: () => void;
    shouldShow: boolean;
    url: string;
}

export default function PdfViewerModal({ onClose, shouldShow, url }: PdfViewerModalProps) {

    const gotoUrl = () => {
        window.open(url, "_blank")
    }
   
    useEffect(() => {
        console.log(url)
    },[])

    return (
        <React.Fragment>
           
            <Modal
                show={shouldShow}
                backdrop="static"
                keyboard={false}
                className="pdf-viewer-modal theme-custom-modal"
                centered
                contentClassName='custom-modal'
            >
                <Modal.Header>
                    <h2>Today's Rodeo</h2>
                    <button type="button" className="rkmd-btn btn-sm btn-orange ripple-effect w-50" onClick={gotoUrl} style={{marginLeft:"10px"}}>See Full Program</button>
                    <button type="button" className="btn-close" onClick={() => onClose()}>
                    </button>
                </Modal.Header>
                <Modal.Body bsPrefix={'-pdf-viewer-modal'}>
                    <div className="modal-body" style={{ overflowX: 'auto' }}>
                        <iframe src={url} width="100%" height="300" />
                       
                             
                    </div>
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}